import { useState } from 'react';
import { Flex, Text, Button } from '@chakra-ui/react';

interface ObservationProps {
  observation?: string;
  maxLength?: number;
  label?: string;
}

const SeeMore: React.FC<ObservationProps> = ({ observation = '', maxLength = 120, label = 'Observação' }) => {
  const [expanded, setExpanded] = useState(false);

  if (!observation) return null;

  const isLongText = observation.length > maxLength;
  const displayText = !expanded && isLongText ? observation.substring(0, maxLength) + '...' : observation;

  return (
    <Flex gap={1} wrap="wrap">
      <Text fontWeight="bold">{label}:</Text>
      <Text dangerouslySetInnerHTML={{ __html: displayText }} as="span" />
      {isLongText && (
        <Button variant="link" colorScheme="blue" size="sm" onClick={() => setExpanded(!expanded)}>
          {expanded ? 'ver menos' : 'ver mais'}
        </Button>
      )}
    </Flex>
  );
};

export default SeeMore;
